module.exports = __webpack_public_path__ + "static/ec-efficacy-mobile-7cee1a90a423b252fd635c231b244b82.png";